export default "__VITE_ASSET__lyEItCxC__"